// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"3e118fc7","845":"367508de"}[chunkId] + ".chunk.js";
};